import React, { useCallback, useState, useEffect, useRef } from 'react'
import emailjs from '@emailjs/browser';
import { createPortal } from "react-dom"
import styles from './ModalForm.module.scss'
import ModalOverlay from '../ModalOverlay/ModalOverlay'
import logo from '../../image/Header/logo.png'
import { FormValidation } from '../../hooks/FormValidation'
import InputMask from "react-input-mask"

const ModalForm = ({onClose, popupOpen, isPrivacyPolicyOpenOpen}) => {

    const modalRoot = document.getElementById("modals");
    
    const handleForm = FormValidation()
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const [isChecked, setIsChecked] = useState(false);
    const form = useRef()

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        };

    useEffect(() => {
        handleForm.isValid ? setButtonDisabled(false) : setButtonDisabled(true)
        isChecked ? setButtonDisabled(false) : setButtonDisabled(true)
    }, [handleForm.isValid, isChecked])

    const sendData = useCallback((evt) => {
        evt.preventDefault();
            emailjs.sendForm('service_qep69aj', 'template_8xdly7l', form.current, '4q-xZF7PEANpcpZ8m')
            .then((result) => {
            }, (error) => {
                console.log(error.text);
            }); 
        onClose()
        handleForm.resetForm()
        popupOpen()
    }, [handleForm, onClose, popupOpen] )

    useEffect(() => {
        const handleEscClose = (evt) =>{
            if (evt.key ==='Escape')  onClose()
        }
        document.addEventListener('keydown', handleEscClose)
        return () => document.removeEventListener('keydown', handleEscClose)
    }, [onClose])

    return createPortal (
        <ModalOverlay onClick={onClose}>
            <div className={styles.modal} onClick={evt => evt.stopPropagation()}>
                <div className={styles.box_logo}>
                    <img className={styles.logo} src={logo} alt='логотип'/>
                    <button data-test="close-button" className={styles.close_icon} type="button" aria-label="закрыть" onClick={onClose}/>
                </div>
                <div className={styles.box}>
                    <h2 className={styles.title}>Получите бесплатную консультацию</h2>
                    <p className={styles.subtitle}>Просто оставьте свои контакты и&nbsp;мы&nbsp;с&nbsp;вами свяжемся</p>
                        <form className={styles.form} onSubmit={sendData} ref={form}>
                            <div className={styles.box_input}>
                                <label className={styles.label}>Введите имя
                                    <input
                                        className={`${styles.input} ${handleForm.errors.name && styles.wrong}`}
                                        type='text' 
                                        name='name'
                                        value={handleForm.values.this}
                                        onChange={handleForm.handleChange} 
                                        pattern='^[A-Za-zА-Яа-яЁё\s\-]{2,30}$'  
                                        required/>
                                </label>
                            </div>
                            <span className={styles.input_error}>{handleForm.errors.name}</span>
                            <div className={styles.box_input}>
                                <label className={styles.label}>Введите телефон      
                                    <InputMask
                                        className={`${styles.input} ${handleForm.errors.phone && styles.wrong}`}
                                        type='tel' 
                                        name='phone'
                                        mask={'+7\\(999) 999-99-99'}
                                        value={handleForm.values.this}
                                        onChange={handleForm.handleChange}  
                                        pattern='\+7\s?[\(][0-9]{3}[\)]{0,1}\s?\d{3}[-]{0,1}\d{2}[-]{0,1}\d{2}'
                                        required/>
                                </label>
                            </div>            
                            <span className={styles.input_error}>{handleForm.errors.phone}</span>
                                    <button className={`${styles.button_form} ${buttonDisabled && styles.button_disabled}`}type='submit'>жду звонка <span className={styles.glare}></span></button>
                                    <div className={styles.box_item}  onClick={() => setButtonDisabled(!buttonDisabled)}>
                                    <div className={styles.icon_boxs}  >
                                    <label className={isChecked ? styles.label_checked : styles.label_checkbox}>
                                        <input 
                                            type="checkbox"
                                            id="yes"
                                            name="yes"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                            style={{
                                                opacity: 0,
                                                position: 'absolute',
                                                width: '100%',
                                                height: '100%',
                                                margin: 0,
                                                cursor: 'pointer'
                                            }}
                                        />
                                        {isChecked && (
                                            <svg className={styles.mark}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#FFFCF7"
                                                strokeWidth="2"
                                            >
                                            <polyline points="20 6 9 17 4 12" />
                                            </svg>
                                        )}
                                        </label>
                                        </div>
                                    <div className={styles.box_text}>
                                        <p className={styles.form_text}>Я предоставляю согласие на обработку персональных данных, а также подтверждаю ознакомление и согласие</p>
                                        <p className={styles.button_link} onClick={isPrivacyPolicyOpenOpen}>с Политикой конфиденциальности</p>
                                    </div>
                                </div>
                        </form>
                        
                </div>
            </div>
        </ModalOverlay>
        ,modalRoot
    );
};

export default ModalForm